export default {
  label: {
    userName: '{name}\'s home page (ID: {id})'
  },
  btn: {
    activeEmployee: 'Activate Now!'
  },
  message: {
    activeEmployeeTip: 'Your employee role has not be activated yet, Click Here to',
    activeEmployee: {
      success: 'We have sent a verification email to your email address, click the link in email, your employee role will be activated automatically.',
      fail: 'Your employee role cannot be activated now, please contact your company HR.'
    }
  }
}
